import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './SignupComponent.css'
import Button from '@material-ui/core/Button'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '@material-ui/core/Input'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { validateEmail, validatePassword } from 'redux/helpers/authHelpers'
const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  formControl: {
    margin: theme.spacing.unit
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3
  }
})

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
class SignupComponent extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    signUp: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
  }
  state = {
    lastName: '',
    firstName: '',
    email: '',
    password: '',
    dashpoolCGS: false,
    showPassword: false,
    emailError: null,
    passwordError: null,
    lastNameError: null,
    firstNameError: null,
    cgsError: null,
    errorMessage: void 0
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.auth && nextProps.auth.errorMessage !== void 0) {
      this.setState({ errorMessage: nextProps.auth.errorMessage })
    }
  }
  onKeyPressed = e => {
    if (e.charCode === 13) {
      // enter key pressed
      e.preventDefault()
      this.handleSignupClick()
    }
  }
  handleChange = prop => e => {
    switch (prop) {
      case 'email':
        this.setState({
          [prop]: e.target.value,
          emailError: null,
          errorMessage: void 0
        })
        break
      case 'firstName':
        this.setState({
          [prop]: capitalizeFirstLetter(e.target.value),
          firstNameError: null,
          errorMessage: void 0
        })
        break
      case 'lastName':
        this.setState({
          [prop]: capitalizeFirstLetter(e.target.value),
          lastNameError: null,
          errorMessage: void 0
        })
        break
      case 'password':
        this.setState({
          [prop]: e.target.value,
          passwordError: null,
          errorMessage: void 0
        })
        break
      case 'dashpoolCGS':
        this.setState({
          [prop]: e.target.checked,
          passwordError: null,
          errorMessage: void 0
        })
        break
      default:
        break
    }
  }
  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleClickShowPasssword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }
  handleSigninClick = e => {
    this.props.history.replace('signin')
  }
  handleSignupClick = e => {
    let errors = {}
    if (!validateEmail(this.state.email)) {
      errors.emailError = 'Email invalide'
    }
    if (this.state.lastName === '') {
      errors.lastNameError = 'Ce champs est obligatoire'
    }
    if (this.state.firstName === '') {
      errors.firstNameError = 'Ce champs est obligatoire'
    }
    if (!validatePassword(this.state.password)) {
      errors.passwordError = 'Mot de passe invalide, (4 caractères minimum)'
    }
    if (!this.state.dashpoolCGS) {
      errors.cgsError = 'Vous devez accepter les CGS Dashpool'
    }
    this.setState({ ...errors })
    if (Object.keys(errors).length === 0) {
      this.props.signUp(
        this.state.email,
        this.state.password,
        this.state.firstName,
        this.state.lastName
      )
    }
  }

  render() {
    const { errorMessage, dashpoolCGS } = this.state
    const { classes } = this.props
    const errorDiv =
      errorMessage !== void 0 ? (
        <div className="errorContainer">
          <span>{errorMessage}</span>
        </div>
      ) : null
    return (
      <section className="signUpContainer">
        <Paper elevation={5} className="centerContainer">
          <form className="form" noValidate autoComplete="off">
            <span>
              {'Vous avez déjà un compte ?'}
              <Button color="secondary" onClick={this.handleSigninClick}>
                Connexion
              </Button>
            </span>
            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
            <Typography
              color="default"
              variant="display1"
              gutterBottom
              align="center">
              Créer un compte
            </Typography>
            <div style={{ padding: 10 }}>
              <FormControl
                error={this.state.emailError}
                fullWidth
                className={classes.formControl}>
                <InputLabel htmlFor="email">Email</InputLabel>
                <Input
                  autoFocus
                  id="email"
                  value={this.state.email}
                  onChange={this.handleChange('email')}
                />
                {this.state.emailError ? (
                  <FormHelperText id="email-error-text">
                    {this.state.emailError}
                  </FormHelperText>
                ) : null}
              </FormControl>
              <FormControl
                error={this.state.lastNameError}
                fullWidth
                className={classes.formControl}>
                <InputLabel htmlFor="lastName">Nom</InputLabel>
                <Input
                  id="lastName"
                  value={this.state.lastName}
                  onChange={this.handleChange('lastName')}
                />
                {this.state.lastNameError ? (
                  <FormHelperText id="lastName-error-text">
                    {this.state.lastNameError}
                  </FormHelperText>
                ) : null}
              </FormControl>
              <FormControl
                error={this.state.firstNameError}
                fullWidth
                className={classes.formControl}>
                <InputLabel htmlFor="firstName">Prénom</InputLabel>
                <Input
                  id="firstName"
                  value={this.state.firstName}
                  onChange={this.handleChange('firstName')}
                />
                {this.state.firstNameError ? (
                  <FormHelperText id="firstName-error-text">
                    {this.state.firstNameError}
                  </FormHelperText>
                ) : null}
              </FormControl>
              <FormControl
                error={this.state.passwordError}
                fullWidth
                className={classes.formControl}>
                <InputLabel htmlFor="password">Mot de passe</InputLabel>
                <Input
                  id="adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  value={this.state.password}
                  onChange={this.handleChange('password')}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={this.handleClickShowPasssword}
                        onMouseDown={this.handleMouseDownPassword}>
                        {this.state.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {this.state.passwordError ? (
                  <FormHelperText id="password-error-text">
                    {this.state.passwordError}
                  </FormHelperText>
                ) : null}
              </FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dashpoolCGS}
                    onChange={this.handleChange('dashpoolCGS')}
                    value="dashpoolCGS"
                  />
                }
                label={
                  <Typography variant="body2" noWrap>
                    J'accepte
                    <Typography variant="caption">
                      <Link
                        target="_blank"
                        to="http://www.hiboutik.fr/cgs_hiboutik_fr.pdf">
                        {`les termes et conditions de service`}
                      </Link>
                    </Typography>
                  </Typography>
                }
              />
            </div>
            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
            <Button
              disabled={!dashpoolCGS}
              variant="raised"
              size="large"
              color="primary"
              onClick={this.handleSignupClick}>
              Créer un compte
            </Button>
            {errorDiv}
            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
          </form>
        </Paper>
      </section>
    )
  }
}
export default withStyles(styles)(withRouter(SignupComponent))



// WEBPACK FOOTER //
// ./src/routes/Signup/components/SignupComponent.js